export const soundCloudGql = /* GraphQL */ `... on landingPageContent2023_embedSoundcloud_BlockType {
  typeHandle
  height
  podcastHref
  podcastName
  trackHref
  trackId
  trackTitle
  width
}`;
